import { render, staticRenderFns } from "./NotSupportBrowser.vue?vue&type=template&id=60f95c5f&"
import script from "./NotSupportBrowser.vue?vue&type=script&lang=ts&"
export * from "./NotSupportBrowser.vue?vue&type=script&lang=ts&"
import style0 from "./NotSupportBrowser.vue?vue&type=style&index=0&id=60f95c5f&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports